"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInteriorPrintableGroup = exports.isCoverPrintableGroup = exports.isInteriorPrintableGroup = exports.isPrintableGroupEmpty = exports.isDehydratedPrintableGroup = exports.isPrintableGroup = exports.dehydratedPrintableGroupRuleSet = exports.printableGroupRuleSet = exports.PRINTABLE_GROUP_TYPE_WOODEN_BOX = exports.PRINTABLE_GROUP_TYPE_INTERIOR = exports.PRINTABLE_GROUP_TYPE_COVER = void 0;
exports.clearPrintableGroup = clearPrintableGroup;
const typeguard_1 = require("./../../types/typeguard");
const Printable_1 = require("./Printable");
exports.PRINTABLE_GROUP_TYPE_COVER = 'cover';
exports.PRINTABLE_GROUP_TYPE_INTERIOR = 'interior';
exports.PRINTABLE_GROUP_TYPE_WOODEN_BOX = 'wooden-box';
exports.printableGroupRuleSet = {
  id: typeguard_1.isNonEmptyString,
  type: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  qty: typeguard_1.isNumber,
  rotateWorkspace: (0, typeguard_1.optional)(typeguard_1.isBool),
  printables: value => !!value && Array.isArray(value) && value.every(v => (0, Printable_1.isPrintable)(v))
};
exports.dehydratedPrintableGroupRuleSet = {
  id: typeguard_1.isNonEmptyString,
  type: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  qty: typeguard_1.isNumber,
  printables: value => !!value && Array.isArray(value) && value.every(v => !!v && typeof v === 'string')
};
function clearPrintableGroup(printableGroup) {
  return Object.assign(Object.assign({}, printableGroup), {
    qty: 1,
    printables: printableGroup.printables.map(printable => (0, Printable_1.clearPrintable)(printable))
  });
}
const isPrintableGroup = pg => (0, typeguard_1.isType)(pg, exports.printableGroupRuleSet);
exports.isPrintableGroup = isPrintableGroup;
const isDehydratedPrintableGroup = pg => (0, typeguard_1.isType)(pg, exports.dehydratedPrintableGroupRuleSet);
exports.isDehydratedPrintableGroup = isDehydratedPrintableGroup;
const isPrintableGroupEmpty = pg => pg.printables.every(Printable_1.isPrintableEmpty);
exports.isPrintableGroupEmpty = isPrintableGroupEmpty;
const isInteriorPrintableGroup = printableGroup => printableGroup.type === exports.PRINTABLE_GROUP_TYPE_INTERIOR;
exports.isInteriorPrintableGroup = isInteriorPrintableGroup;
const isCoverPrintableGroup = printableGroup => printableGroup.type === exports.PRINTABLE_GROUP_TYPE_COVER;
exports.isCoverPrintableGroup = isCoverPrintableGroup;
const getInteriorPrintableGroup = printableGroups => printableGroups.filter(exports.isInteriorPrintableGroup).shift();
exports.getInteriorPrintableGroup = getInteriorPrintableGroup;